<div class="preferences-dock" [attr.aria-label]="interfaceDockLabel()">
  <div class="preferences-dock__lang" role="group" [attr.aria-label]="languageLabel()">
    <button
      type="button"
      class="preferences-dock__lang-btn"
      [class.preferences-dock__lang-btn--active]="language.currentLang() === 'es'"
      (click)="setLang('es')"
      aria-pressed="{{ language.currentLang() === 'es' }}"
    >
      ES
    </button>
    <span class="preferences-dock__lang-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3M12 21C14.2513 21 16.0764 16.9706 16.0764 12C16.0764 7.02944 14.2513 3 12 3M12 21C9.74873 21 7.92358 16.9706 7.92358 12C7.92358 7.02944 9.74873 3 12 3M4 9H20M4 15H20" />
      </svg>
    </span>
    <button
      type="button"
      class="preferences-dock__lang-btn"
      [class.preferences-dock__lang-btn--active]="language.currentLang() === 'en'"
      (click)="setLang('en')"
      aria-pressed="{{ language.currentLang() === 'en' }}"
    >
      EN
    </button>
  </div>

  <button
    type="button"
    class="theme-fab"
    (click)="darkMode.toggle()"
    [title]="themeToggleLabel()"
    [attr.aria-label]="themeToggleLabel()"
  >
    @if (darkMode.isDark()) {
      <svg class="theme-fab__icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
        />
      </svg>
    } @else {
      <svg class="theme-fab__icon" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
        />
      </svg>
    }
  </button>
</div>
